import { render, staticRenderFns } from "./normalNotice.vue?vue&type=template&id=43fabb9e&scoped=true"
import script from "./normalNotice.vue?vue&type=script&lang=js"
export * from "./normalNotice.vue?vue&type=script&lang=js"
import style0 from "./normalNotice.vue?vue&type=style&index=0&id=43fabb9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fabb9e",
  null
  
)

export default component.exports